module.exports = __webpack_public_path__ + "static/media/dados_icon.097e829d.svg";